(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbStatusConfigService', [
			'$http',
			'$q',
			'pxUriPathService',
			StatusConfigService
		]);

	function StatusConfigService($http, $q, pxUriPathService) {

		return {
			getStatuses: getStatuses,

			setStatuses: setStatuses
		};

		function getStatuses(groupId) {
			if (!(typeof groupId === 'string' || typeof groupId === 'number')) {
				return $q.reject(new Error('Missing required document type group id'));
			}

			var uri = pxUriPathService.resolvePath('/libraries/' + groupId + '/tagtypes');
			return $http.get(uri)
				.then(function(res) {
					return res.data.filter(function statuses(tt) {
						return tt.TagTypeName.match(/&&_AirBase_.*/);
					});
				});
		}

		function setStatuses(folderId, tagTypeId, constraints) {
			if (!(typeof folderId === 'string' || typeof folderId === 'number')) {
				return $q.reject(new Error('Missing required document type id'));
			} else if (!constraints) {
				return $q.reject(new Error('Must specify the constraints to add to the document type.'));
			}

			var uri = pxUriPathService.resolvePath('/f/' + folderId + '/tagtypes/' + tagTypeId + '/constraints');
			return $http.put(uri, constraints)
				.then(function() {
					return constraints;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/contentConfigServices/statusConfigService.js
// module id = 139
// module chunks = 1